Object.defineProperty(exports, "__esModule", { value: true });
exports.convertNativeEnumToGraphQLEnumValues = void 0;
function validateForGraphqlJs(val) {
    if (!val.match(/^[_a-zA-Z][_a-zA-Z0-9]*$/)) {
        // https://github.com/graphql/graphql-js/issues/936#issuecomment-349887156
        throw new Error(`enum key "${val}" cannot be exposed on graphql`);
    }
}
function convertNativeEnumToGraphQLEnumValues(enumDef, fieldsConfig, useKeys = false) {
    const valueConfigMap = {};
    Object.entries(enumDef).forEach(([key, val]) => {
        if (!isNaN(key)) {
            return;
        }
        const fieldConfig = fieldsConfig && fieldsConfig[key];
        if (typeof val === 'string' && useKeys === false) {
            validateForGraphqlJs(val);
            valueConfigMap[val] = {
                value: val,
                deprecationReason: fieldConfig === null || fieldConfig === void 0 ? void 0 : fieldConfig.deprecationReason,
                description: fieldConfig === null || fieldConfig === void 0 ? void 0 : fieldConfig.description
            };
        }
        else {
            validateForGraphqlJs(key);
            valueConfigMap[key] = {
                value: val,
                deprecationReason: fieldConfig === null || fieldConfig === void 0 ? void 0 : fieldConfig.deprecationReason,
                description: fieldConfig === null || fieldConfig === void 0 ? void 0 : fieldConfig.description
            };
        }
    });
    return valueConfigMap;
}
exports.convertNativeEnumToGraphQLEnumValues = convertNativeEnumToGraphQLEnumValues;
//# sourceMappingURL=convertNativeEnumToGraphQLEnumValues.js.map